<template>
    <div class="marriage-report-result-button-unlock">
        <button class="marriage-submit-btn" @click="clickPay" >
            <!-- 加载状态 -->
            <span v-if="buttonLocked" class="report-rbul-button-span">
                <div class="lds-default report-rbul-button-loading"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                <span class="report-rbul-button-span-loading">报告解锁生成中</span>
            </span>
            <!-- 正常状态:付费解锁 -->
            <span class="marriage-submit-btn-span" v-else>
                {{ vipBtn ? '特权免费解锁本页完整报告' : buttonText }}
            </span>
        </button>
        <div class="marriage-submit-btn-text">终身会员可免费解锁，更多会员权益请点击查看！</div>
    </div>
</template>

<script>
export default {
    name: 'MarriageReportButton',
    props: {
        buttonText: {
            type: String,
            default() {
                return '解锁'
            }
        },
        clickFunc: {
            type: Function,
            default() {
                return function(){}
            }
        },
        vipBtn: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data() {
        return {
            buttonLocked: false
        }
    },
    methods: {
        clickPay() {
            if(this.buttonLocked) { return; }
            this.buttonLocked = true;
            var me = this;
            if(this.clickFunc && typeof(this.clickFunc) == 'function') {
                this.clickFunc({
                    cb: function() {
                        me.buttonLocked = false;
                    }
                });
                setTimeout(() => {
                    me.buttonLocked = false;
                }, 5000);
            }
        }
    }
}
</script>